import React from "react";
import AttendanceRecordsShared from "../attendance/AttendanceRecordsShared";

export default function AttendanceRecords() {
  return <AttendanceRecordsShared backPath="/technician/attendance" />;
}
